import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'

import BuildPassLogoSmall from 'public/buildpass-small.svg'
import BuildPassLogo from 'public/buildpass.svg'
import ProjectIconWithoutLogo from 'public/project-icon-without-logo.svg'
import ProjectIcon from 'public/project-icon.svg'

interface WhiteLabelContextType {
  logoSmall: string
  logoLarge: string
  logoResponsive: string
  projectIcon: string
  hideBuildPassLogos: boolean
  setWhiteLabelConfig: (config: Config) => void
}

const WhiteLabelContext = createContext<WhiteLabelContextType>({
  logoSmall: '',
  logoLarge: '',
  logoResponsive: '',
  projectIcon: '',
  hideBuildPassLogos: false,
  setWhiteLabelConfig: () => {},
})

type Config = {
  logoUrl?: string
  hideBuildPassLogos?: boolean
}

type Props = {
  children?: React.ReactNode
}

export const WhiteLabelProvider: React.FC<Props> = ({ children }) => {
  const [whiteLabelConfig, setWhiteLabelConfig] = useState<Config>(null)

  const useBuilderLogo =
    whiteLabelConfig?.hideBuildPassLogos && !!whiteLabelConfig?.logoUrl

  const logos = useMemo(() => {
    return {
      logoSmall: useBuilderLogo
        ? whiteLabelConfig.logoUrl
        : BuildPassLogoSmall.src,
      logoLarge: useBuilderLogo ? whiteLabelConfig.logoUrl : BuildPassLogo.src,
      logoResponsive: useBuilderLogo
        ? whiteLabelConfig.logoUrl
        : // : isSmall
          //   ? BuildPassLogoSmall.src
          BuildPassLogo.src,
      projectIcon: useBuilderLogo
        ? ProjectIconWithoutLogo.src
        : ProjectIcon.src,
      hideBuildPassLogos: useBuilderLogo,
    }
  }, [useBuilderLogo, whiteLabelConfig?.logoUrl])

  return (
    <WhiteLabelContext.Provider value={{ ...logos, setWhiteLabelConfig }}>
      {children}
    </WhiteLabelContext.Provider>
  )
}

export const useWhiteLabelling = () => useContext(WhiteLabelContext)

export const useSetWhiteLabelling = (config: Config) => {
  const { setWhiteLabelConfig } = useContext(WhiteLabelContext)
  const hasSet = useRef(false)

  useEffect(() => {
    if (!hasSet.current) {
      hasSet.current = true
      setWhiteLabelConfig(config)
    }
  }, [config, setWhiteLabelConfig])
}
